import styled from 'styled-components'
import React from 'react'
import icon from '../RelatedScenarios/icons/icon.svg'
import { DriversImg } from '../RelatedScenarios/styles'

const RadioBoxForFpScenarios = ({
  isFpGroup,
  label = '',
  value,
  checked = false,
  onClick,
  large = false,
  className,
  phenomenaState,
  disabled,
  nameRadio,
}) => {
  return (
    <div className={`fp-radiobox ${className || ''}`} onClick={onClick}>
      <input
        name={`${label}-${nameRadio}`}
        value={value}
        type={'radio'}
        checked={checked}
        readOnly
        disabled={disabled}
      />
      {label !== '' && (
        <PhenomenaLabel
          style={large ? { fontSize: '16px', paddingLeft: '30px' } : {}}>
          {phenomenaState && (
            <PhenomenaState>
              <DriversImg
                src={icon}
                className="scenario-link"
                //   data-href={`fp-scenario-card/${gid}/${scenarioSetId}/${scenario?.id}`}
                //   data-uri={`fp-scenario-card/${gid}/${scenarioSetId}/${scenario?.id}`}
              />
            </PhenomenaState>
          )}
          {label}
        </PhenomenaLabel>
      )}
    </div>
  )
}

const PhenomenaLabel = styled.label`
  display: flex;
  align-items: center;
  color: black !important;
`

const PhenomenaState = styled.div`
  height: 100%;
  width: 25px;
  margin-right: 6px;
  display: flex;
  align-items: center;
`

export default RadioBoxForFpScenarios
